<template>
  <div>
    <div class="content">
      {{ content }}
    </div>
  </div>
</template>

<script>
import { computed, defineComponent } from "vue";

export default defineComponent({
  props: {
    node: Text,
  },
  setup(props) {
    const content = computed(() => props.node.textContent);

    return {
      content,
    };
  },
});
</script>

<style lang="scss" scoped>
@import "@/assets/stylesheet/_variables.scss";

.content {
  color: $elementContentColor;
}
</style>
